export default "__VITE_ASSET__DheVG5HZ__"